import { ui } from '@/constants';
import { IngredientGroupItemMetaData, MonoMenuEntree, Recipe, MonoMenuTileItem, IngredientMetadata, IngredientGroupMetadata, RecipeGroup } from '@/models';
import { INGREDIENTS_METADATA_COUNTRIES } from '@/services/metadata/metadata.service';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgRecipesBanner'
})
export default class CmgRecipesBanner extends Vue {

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.tablet;
  }

  get expanded(): boolean {
    return this.$appStore.state.ui.ingredientsPage.isRecipeBannerExpanded;
  }

  get selectedDistanceLeft(): number {
    return this.$appStore.state.ui.ingredientsPage.selectedRecipeDistance;
  }

  get isRecipeVisible(): boolean {
    return this.$appStore.state.ui.ingredientsPage.isSelectedRecipeVisible;
  }

  get titleText(): string {
    return this.expanded ? 'Back to all 53 Real Ingredients that make our recipes' : 'See how these 53 Real Ingredients make our recipes'
  }

  get iconText(): string {
    return this.expanded ? 'x' : '+'
  }

  get ingredientsMetadata(): IngredientMetadata[] {
    return this.$appStore.state.menu.ingredientsMetadata[INGREDIENTS_METADATA_COUNTRIES.US]?.data?.ingredients || [];
  }
  
  get ingredientGroupsMetadata(): IngredientGroupMetadata[] {
    return this.$appStore.state.menu.ingredientsMetadata[INGREDIENTS_METADATA_COUNTRIES.US]?.data?.ingredientGroups || [];
  }

  get recipeGroups(): RecipeGroup[] {
    return this.$appStore.state.monoMenu.recipeGroups;
  }

  get recipeIsSelected(): boolean {
    return !!this.selectedRecipe;
  }

  get selectedRecipe(): Recipe | null {
    return this.$appStore.state.ui.ingredientsPage.selectedRecipe;
  }

  get showSelectedPointer() {
    return this.isRecipeVisible && !this.isMobile;
  }

  async mounted() {
    await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
  }

  onScroll() {
    this.setPointerVisibility();
  }

  onClickExpand() {
    this.$services.ui.setRecipeBannerExpanded(!this.expanded);

    if (!this.expanded) {
      this.$services.ui.setRecipe(null);
      this.$services.ui.setIngredients(this.$appStore.state.menu.ingredientsMetadata[INGREDIENTS_METADATA_COUNTRIES.US]?.data?.ingredients || []);
    }
  }

  isRecipeSelected(item: Recipe) {
    return item.itemId == this.$appStore.state.ui.ingredientsPage.selectedRecipe?.itemId;
  }

  selectRecipe(recipe: Recipe) {
    const recipeIngredients = this.$appStore.state.menu.ingredientsMetadata[INGREDIENTS_METADATA_COUNTRIES.US]?.data?.ingredients.filter(x => recipe.ingredients.includes(x.key)) || [];
    
    this.$services.ui.setRecipe(recipe);
    this.$services.ui.setIngredients(recipeIngredients);
    this.setPointerVisibility();
  }

  getDisplayName(item:  [MonoMenuTileItem | undefined, IngredientGroupItemMetaData]): string {
      return (item[0] as MonoMenuEntree).primaryFillingName ?? item[0]?.itemName;
  }

  setPointerVisibility() {
    if (this.selectedRecipe) {
      const selectedElements = this.$refs[this.selectedRecipe.itemId] as HTMLElement[];
      const groupsContainer = this.$refs.groupsContainer as HTMLElement;

      if (selectedElements && selectedElements[0]) {
        this.$services.ui.setSelectedRecipeDistance(selectedElements[0].getBoundingClientRect().left + 25);
        this.$services.ui.setSelectedRecipeVisible(this.selectedDistanceLeft > groupsContainer.getBoundingClientRect().left && (this.selectedDistanceLeft + 80) < groupsContainer.getBoundingClientRect().right);
      }
    }
  }
}
